function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 18a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m-7 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m-7 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2M8.5 3.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5S10.827 5 10 5s-1.5-.673-1.5-1.5M18 14.185V12c0-1.654-1.346-3-3-3h-4V6.837c1.44-.434 2.5-1.757 2.5-3.337C13.5 1.57 11.93 0 10 0S6.5 1.57 6.5 3.5c0 1.58 1.06 2.903 2.5 3.337V9H5c-1.654 0-3 1.346-3 3v2.185A2.995 2.995 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3a2.993 2.993 0 0 0-2-2.815V12c0-.551.449-1 1-1h4v3.185A2.995 2.995 0 0 0 7 17c0 1.654 1.346 3 3 3s3-1.346 3-3a2.993 2.993 0 0 0-2-2.815V11h4c.552 0 1 .449 1 1v2.185A2.995 2.995 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3a2.993 2.993 0 0 0-2-2.815",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgIntegrations = function SvgIntegrations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegrations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Integrations.124758af.svg";
export { ForwardRef as ReactComponent };